import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-resource-accordion',
  templateUrl: './resource-accordion.component.html',
  styleUrls: ['./resource-accordion.component.css']
})
export class ResourceAccordionComponent implements OnInit {

  data: any
  isExpanded: boolean = false;
  accordionData: any[] = []

  ngOnInit(): void {
    this.accordionData = this.data?.accordionModule.map(accordion => ({...accordion, expanded: false}))

  }

  onToggleButtonClicked(index: number) {
    const updatedData: any = [...this.accordionData]
    updatedData[index].expanded = updatedData[index].expanded ? false : true;
    this.accordionData = updatedData
  }

  getIcons(expanded) {
    return !expanded ? 'add-bold' : 'substract-bold'
  }
}
